<template>
	<div class="customFixed-vue alertPOP darkFadeBG loginInfo" @click.stop="">
	    <div class="custom-modal showTabs secondary-color openHeader">
	    	<app-loader v-if="pageLoader"/>
	    	<div class="mainContent">
	    		<div class="topSettingHead position-relative border-bottom p-3">
	    			<p class="f-14 mb-0">{{$t('create_demo_account') }}</p>
					<span class="closePOP" @click.prevent="$parent.page_type = ''" v-if="get_user.hasOwnProperty('loggedIn') && get_user.loggedIn"><feather size="13px" type="x"></feather></span>
	    		</div>
	    		<div class="mainTab-one pb-3">
		    	<form class="updateWrap" @submit.prevent.stop="registerDemo()">
		    		<div class="twoColmn d-flex align-items-center p-0">
			    		<div class="form-fields px-0 mr-4" :class="[{'validation-error':submitted && errors.has('fname')}]">
							<input type="text" :placeholder="$t('first_name')" name="fname" v-model="fname" v-validate="'required|max:20'" ref="fnameInput" maxlength="20">
							<span class="text-danger-error" v-if="submitted && errors.has('fname')">
								<span class="text-danger">{{ errors.first('fname').replace('fname','First name') }}</span>
							</span>
						</div>
			    		<div class="form-fields px-0" :class="[{'validation-error':submitted && errors.has('lname')}]">
							<input type="text" :placeholder="$t('last_name')" name="lname" v-model="lname" v-validate="'required|max:20'" ref="lnameInput" maxlength="20">
							<span class="text-danger-error" v-if="submitted && errors.has('lname')">
								<span class="text-danger">{{ errors.first('lname').replace('lname','Last name') }}</span>
							</span>
						</div>
					</div>
					<div class="form-fields px-0" :class="[{'validation-error':submitted && errors.has('password')}]">
                        <div class="position-relative">
                            <input :type="(showPass)?'text':'password'" :placeholder="$t('enter_new_password')" v-model="password" v-validate="{ required: true,regex: /^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*/])\S{6,15}$/}" ref="passwordInput" name="password" autocomplete="off" maxlength="20"/><!-- (?=.*[A-Z]) -->
                            <feather :type="(showPass)?'eye':'eye-off'" @click="showPass = !showPass"></feather>
                        </div>
                        <span class="text-danger-error" v-for="error in errors.collect('password')">
	                        <span class="text-danger" v-show="submitted && error == 'The password field is required'">
								{{$t('password_required') }} </span>
	                        <span class="text-danger" v-show="submitted &&error == 'The password field format is invalid'">
								{{$t('password_validation') }}</span>
	                    </span>
	                </div>
		    		<div class="form-fields px-0" :class="[{'validation-error':submitted && errors.has('email')}]">
						<input type="text" :placeholder="$t('email_placeholder')" name="email" v-model="email" v-validate="'required|email|max:75'" ref="emailInput" maxlength="50">
						<span class="text-danger-error" v-if="submitted && errors.has('email')">
							<span class="text-danger">{{ errors.first('email') }}</span>
						</span>
					</div>
		    		<!-- <div class="form-fields">
		    			<input type="text" placeholder="Enter Phone No." name="">
		    		</div> -->
		    		<div class="twoColmn d-flex align-items-center p-0">
			    		<div class="form-fields px-0 mr-4" :class="[{'validation-error':submitted && errors.has('currency')}]">
							<select class="selectBox" v-model="currency" name="currency" v-validate="'required'" ref="currencyInput">
								<option value="" disabled>{{$t('select_currency') }} </option>
								<option value="USD">{{$t('usd') }} </option>
								<option value="EUR">{{$t('eur') }} </option>
								<option value="GBP">{{$t('gbp') }} </option>
								<option value="AUD">{{$t('aud') }} </option>
							</select>
							<span class="text-danger-error" v-if="submitted && errors.has('currency')">
								<span class="text-danger">{{ errors.first('currency') }}</span>
							</span>
						</div>
						<div class="form-fields px-0" :class="[{'validation-error':submitted && errors.has('leverage')}]">
							<select class="selectBox" v-model="leverage" name="leverage" v-validate="'required'" ref="leverageInput">
								<option value="" disabled>{{$t('select_leverage') }} </option>
								<option value="100">100{{$t('x') }} </option>
								<option value="200">200{{$t('x') }}</option>
								<option value="300">300{{$t('x') }}</option>
								<option value="400">400{{$t('x') }}</option>
								<option value="500">500{{$t('x') }}</option>
							</select>
							<span class="text-danger-error" v-if="submitted && errors.has('leverage')">
								<span class="text-danger">{{ errors.first('leverage') }}</span>
							</span>
						</div>
					</div>
					<div class="form-data">
						<div class="form-fields px-0 m-0 h-50p" :class="[{'validation-error':submitted && errors.has('Amount')}]">
							<div class="lightBC d-flex align-items-center darkBG">
								<label class="amountType justify-content-center">{{$t('amount') }}</label>
				    			<input type="number" placeholder="" name="Amount" v-model="amount" v-validate="'required|decimal:2'" ref="AmountInput" autocomplete="off" >
				    			<!-- <span class="addHighLow">
                                    <a href="#" @click.prevent="changeTick('AmountInput',1,'amount')"><feather type="plus"></feather> </a>
                                    <a href="#" @click.prevent="changeTick('AmountInput',0,'amount')"><feather type="minus"></feather> </a>
                                </span> -->
				    		</div>
				    		<span class="text-danger-error" v-if="submitted && errors.has('Amount')">
					    		<span class="text-danger">{{ errors.first('Amount') }}</span>
					    	</span>
				    		<span class="text-danger-error" v-else-if="parseFloat(amount) > 100000">
					    		<span class="text-danger">{{$t('amount_greater_100000') }} </span>
					    	</span>
			    		</div>
		    		</div>
		    		
		    		<!-- <div class="form-fields">
		    			<p>We will offer you a free $1000.00 demo forex trading account with no risk.</p>
					</div> -->
					<div class="fullWidh d-flex align-items-center justify-content-between text-center mt-4 mb-3">
						<a href="#" class="btn appButton redBG justify-content-center" v-if="!(get_user.hasOwnProperty('loggedIn') && get_user.loggedIn)"  @click.prevent="$parent.page_type = 'login'">{{$t('back') }}</a>
						<button class="btn appButton linkBG justify-content-center">{{$t('register') }} </button>
						<!-- <p v-if="(get_user.hasOwnProperty('loggedIn') && get_user.loggedIn)">For a live trading account, Please <a href="#">Click Here</a></p> -->
					</div>
					<div class="form-fields mt-3" v-if="!(get_user.hasOwnProperty('loggedIn') && get_user.loggedIn)">
						<!-- <p>For a live trading account, Please <a href="#">Click Here</a></p> -->
					</div>
				</form>
			    </div>
	    	</div>
	    </div>
    </div>
</template>

<script>
import { commonAllmixins } from '@/plugins/commonAll';
import * as types from '@/types';
const DEMO_SERVER = process.env.DEMO_SERVER;
import UserDB from '@/store/userDB';
export default {
    name: 'login-pop',
    mixins: [commonAllmixins,UserDB],
    data() {
        return {
        	pageLoader : false,
            // change-password
            fname: '',
            lname: '',
            password: '',
            showPass: false,
            email: '',
            currency: '',
            amount: '',
            leverage: '',
            submitted : false,
        }
    },
    watch:{
        amount(val){
            this.amount = val.toString()
                .replace(/[^\d.]/g, '')             // numbers and decimals only
                .replace(/(^[\d]{6})[\d]/g, '$1')   // not more than 6 digits at the beginning
                .replace(/(\..*)\./g, '$1')         // decimal can't exist more than once
                .replace(/(\.[\d]{2})./g, '$1');    // not more than 2 digits after decimal
        },
        fname(val){
            this.fname = val.replace(/\W|\d/g, '');
        },
        lname(val){
            this.lname = val.replace(/\W|\d/g, '');
        },
    },
    methods:{
    	registerDemo(){
    		const _that = this
            _that.submitted = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let inputJson={
                        'globalParams' :{
                            'firstname' : _that.fname.trim(),
                            'lastname' : _that.lname.trim(),
                            'password' : _that.password.trim(),
                            'email' : _that.email.trim(),
                            'currency' : _that.currency,
                            'amount' : _that.amount,
                            'leverage' : _that.leverage,
                        },
                        'localParams' : { "parameter" : _that }
                    }
                    this._runCreateDemoAcc(inputJson)
                }/*else{
                    _that.handleValidationErrorAdvanced(_that.errors)
                }*/
            });
    	},
    	login(data){
    		this.$cookies.set("email",data.traderId,"14d");
			this.$cookies.set("password",data.password,"14d");
			this.$cookies.set("server",DEMO_SERVER,"14d");
			this.$cookies.set("remember",true,"14d");
            let input_json={
                'globalParams' :{
                    'email' : data.traderId.trim(),
                    'password' : data.password.trim(),
                    'server_type' : DEMO_SERVER,
                },
                'localParams' :{ "parameter" : this }
            }
            this.$store.dispatch(types.RUN_LOGIN,input_json)
        },
		addUser() {
			this.saveUser(this.Username, this.server, this.password).then(() => {
				location.reload();
			}).catch((err) =>{
				alert("Error adding user:", err);
				location.reload();
			});
		},
	},
    mounted() {
			const _that = this
	        $(document).on("click", function(event){
				if(!$(event.target).closest('.openHeader').length){
	                _that.openHeader = false
	            }
	        });
		}
    
}
</script>





// WEBPACK FOOTER //
// src/components/website/shared/register.vue